/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-11-01 16:04:32
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-09-11 11:09:03
 */
//重写Number的toFixed方法，解决四舍五入精度问题
Number.prototype.toFixedRound = function (n) {
  // n为期望保留的位数，超过限定，报错！
  if (n > 20 || n < 0) {
    throw new RangeError('toFixed() digits argument must be between 0 and 20')
  }
  // 获取数字
  const number = this
  // 如果是NaN,或者数字过大，直接返回'NaN'或者类似'1e+21'的科学计数法字符串
  if (isNaN(number) || number >= Math.pow(10, 21)) {
    return number.toString()
  }
  // 默认保留整数
  if (typeof (n) == 'undefined' || n == 0) {
    return (Math.round(number)).toString()
  }

  // 先获取字符串
  let result = Math.abs(number).toString()
  // 获取小数部分
  const arr = result.split('.')

  // 整数的情况，直接在后面加上对应个数的0即可
  if (arr.length < 2) {
    result += '.'
    for (let i = 0; i < n; i += 1) {
      result += '0'
    }
    return number < 0 && result > 0 ? -result : result
  }

  // 整数和小数
  const integer = arr[0]
  const decimal = arr[1]
  // 如果已经符合要求位数，直接返回
  if (decimal.length == n) {
      return number < 0 && result > 0 ? -result : result
  }
  // 如果小于指定的位数，补上
  if (decimal.length < n) {
    for (let i = 0; i < n - decimal.length; i += 1) {
      result += '0'
    }
    return number < 0 && result > 0 ? -result : result
  }
  // 如果到这里还没结束，说明原有小数位多于指定的n位
  // 先直接截取对应的位数
  result = integer + '.' + decimal.substr(0, n)
  // 获取后面的一位
 let last = decimal.substr(n, 1)
 if (/^\d(9){5,}[89]$/.test(decimal.substr(n))) {
    last += last + 1
  }
  // 大于等于5统一进一位
  if (parseInt(last, 10) >= 5) {
    // 转换倍数，转换为整数后，再进行四舍五入
    const x = Math.pow(10, n)
    // 进一位后，转化还原为小数
    result = (Math.round((parseFloat(result) * x)) + 1) / x
    // 再确认一遍
    result = result.toFixed(n)
  }
  return number < 0 && result > 0 ? -result : result
}

Number.prototype.add = function (n2) {
  // 获取数字
  const n1 = this
  let pow = Math.max(n1.toString().split('.')[1].length, n2.toString().split('.')[1].length)
  let base = Math.pow(10, pow)

  return (Number(n1.toString().replace('.', '')) + Number(n2.toString().replace('.', ''))) / base
}
